module.exports = __webpack_public_path__ + "static/media/slideshow-20.c91aed73.jpg";